import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import React from "react";

import { EventActions } from "../../../../../redux/actions";
import { allSharedComponents } from "../../../../../shared";
import {
  dateToUTCWithTimezone,
  toSingleDateStringIfEqual,
  serverFormatToMomentObject,
  formatDateTimeRangeFromServer,
} from "../../../../../system";
import {
  TimeIcon,
  CalendarIcon,
  LocationIcon,
  LogoPlaceholder,
} from "../../../../../assets/images/icon";
import {
  Directions,
  eventConstants,
  viewPathConstants,
  timezoneConstants,
  translationConstants,
} from "../../../../../constants";

const { StopPropagation, ServerFormatToDate } = allSharedComponents;

const MyEventCard = ({ event, city, onCancelRegistration }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const direction = useSelector((state) => {
    return state.LanguageChangeReducer.direction;
  });
  const isMobile = useSelector((state) => {
    return state.systemReducer.isMobile;
  });

  const viewDetail = () => {
    dispatch(EventActions.resetGetEventById());
    navigate(
      `${viewPathConstants.MY_EVENTS_DETAIL}?${eventConstants.EVENT_ID}=${event?.id}`,
      {
        state: {
          eventId: event?.id,
          isActive: event?.isActive,
        },
      }
    );
  };

  return (
    <>
      <div className="col-md-12 py-2 text-black">
        <div
          className="activity-card cast-shadow-on-hover"
          onClick={() => {
            viewDetail();
          }}
        >
          <div className="row m-0 gap-md-0">
            <div className="col-md-1 col-lg-1 d-none d-md-none d-lg-block d-flex justify-content-md-center align-items-md-center px-1 text-md-center">
              <span className="activity-date" dir={Directions.ltr}>
                <ServerFormatToDate dateString={event?.startDateString} />
              </span>
            </div>
            <div className="col-12 col-md-10 col-lg-5">
              <div className="d-flex flex-wrap flex-sm-nowrap align-items-center justify-content-center justify-content-md-start gap-4">
                <div className="row w-100">
                  <div className="col-5 col-md-4 col-lg-4 d-lg-flex gap-3 justify-content-start">
                    <div className="competition-content-wrapper"></div>
                    <div
                      className={`activity-card-image-wrapper ${
                        isMobile ? "h-100" : "h-100px"
                      }`}
                    >
                      <img
                        src={
                          event?.logo?.link
                            ? event?.logo?.link
                            : LogoPlaceholder
                        }
                        alt="Event Logo"
                      />
                    </div>
                  </div>
                  <div className="col-7 col-md-5 col-lg-7 ps-3 d-flex flex-column justify-content-between">
                    <div className="d-flex flex-column">
                      <h5 className="activity-card-heading text-ellipsis">
                        {direction === Directions.rtl && event?.arabicTitle
                          ? `${event?.arabicTitle}`
                          : `${event?.title}`}
                      </h5>
                    </div>
                    <div className="">
                      <div className="d-flex gap-1 flex-column">
                        <div className="contact-information-card pt-md-2 d-flex gap-2 pt-0">
                          <img
                            alt="Location Icon"
                            name="activitySpot"
                            src={LocationIcon}
                          />
                          <span
                            className={`${isMobile ? "font-12" : "font-14"}`}
                          >
                            {direction === Directions.rtl
                              ? event?.spotInfo?.arabicSpotName ||
                                event?.spotInfo?.spotName
                              : event?.spotInfo?.spotName}
                            {direction === Directions.rtl
                              ? city?.arabicName || city?.name
                              : city?.name}
                          </span>
                        </div>

                        <div className="row">
                          <div className="d-lg-flex ">
                            <div className="col-12 col-md-12 col-lg-12">
                              <div
                                className={`contact-information-card pt-1 d-flex gap-2`}
                              >
                                <img
                                  alt="Calendar Icon"
                                  name="activityDate"
                                  src={CalendarIcon}
                                />
                                <span
                                  className={`${
                                    isMobile ? "font-12" : "font-14"
                                  }`}
                                >
                                  {toSingleDateStringIfEqual(
                                    event?.startDateString,
                                    event?.endDateString
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className={`d-block d-md-none contact-information-card-wrapper ${
                            isMobile ? "font-12" : "font-14"
                          }`}
                        >
                          <div className="contact-information-card d-flex gap-2">
                            <img
                              alt="Time Icon"
                              name="activityDate"
                              src={TimeIcon}
                            />
                            <span>
                              {formatDateTimeRangeFromServer(
                                event?.startDateString,
                                event?.endDateString,
                                timezoneConstants.hourMinuteFormat
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-12 col-lg-6 mt-3 mt-md-0 gap-2 d-flex justify-content-between">
              <div className="col-5 col-md-5 col-lg-8 h-100 flex-wrap d-flex justify-content-between">
                <div className="col-md-7 col-12 d-none d-md-flex flex-column justify-content-end">
                  <div className="contact-information-card pt-1 d-flex gap-2">
                    <img alt="Time Icon" name="activityDate" src={TimeIcon} />
                    <span>
                      {formatDateTimeRangeFromServer(
                        event?.startDateString,
                        event?.endDateString,
                        timezoneConstants.hourMinuteFormat
                      )}
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-7 col-md-5 col-lg-4 d-flex justify-content-md-center ps-2 ps-md-0 align-items-center">
                <div className="d-flex flex-column align-items-center justify-content-center gap-3">
                  {!event?.isActive ? (
                    <StopPropagation>
                      <Button
                        className="registration-invite-only m-0"
                        disabled={true}
                      >
                        {t(translationConstants.CANCELLED)}
                      </Button>
                      {event?.refundedAmount > 0 && (
                        <div className="text-center pt-1">
                          <span className="text-black font-weight-700 font-14">
                            {t(translationConstants.REFUNDED) + ":"}
                          </span>
                          <span className="ps-2">
                            {event?.refundedAmount?.toFixed(2)}
                          </span>
                        </div>
                      )}
                    </StopPropagation>
                  ) : dateToUTCWithTimezone().isSameOrBefore(
                      serverFormatToMomentObject(event?.startDateString)
                    ) ? (
                    <StopPropagation>
                      <Button
                        className="btn-cancel-outline m-0"
                        type="button"
                        onClick={() => {
                          onCancelRegistration(
                            translationConstants.CANCEL_REGISTRATION,
                            event
                          );
                        }}
                      >
                        {event?.isPublicRegistrationAllowed
                          ? t(translationConstants.CANCEL_REGISTRATION)
                          : t(translationConstants.CANCEL_INVITE)}
                      </Button>
                    </StopPropagation>
                  ) : (
                    dateToUTCWithTimezone().isSameOrBefore(
                      serverFormatToMomentObject(event?.endDateString)
                    ) && (
                      <StopPropagation>
                        <Button
                          className="registration-invite-only customBtnforCompetionInProgress m-0"
                          type="button"
                          disabled={true}
                        >
                          {t(translationConstants.EVENT_IN_PROGRESS)}
                        </Button>
                      </StopPropagation>
                    )
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MyEventCard;
